import store from "../store-root";
import http from "../../service/api";
import queryString from "query-string";

const moduleName = "alarm";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    enterprises: []
  },
  actions: {
    // 获取报警列表
    async getNotifyResidueNum ({ commit }, payload) {
      let result = await http.get(`/api/Enterprise/GetNotifyResidueNum`);
      return result.data;
    },
    // 获取报警列表
    async getAlarmLists ({ commit }, payload) {
      let result = await http.get(`/api/EquipmentAlarm/GetAlarmList`);
      return result.data;
    },
    // 根据Id获取报警设置
    async getSingleAlarm ({ commit }, payload) {
      let result = await http.get(
        `/api/EquipmentAlarm/GetSingleAlarm?Id=${payload}`
      );
      return result.data;
    },
    // 获取基地或者塘口
    async getBasePond ({ commit }, payload) {
      let result = await http.get(`/api/EquipmentAlarm?Id=${payload}`);
      return result.data;
    },
    // 根据基地塘口获取设备列表
    async getEquipmentList ({ commit }, payload) {
      let result = await http.get(`/api/EquipmentAlarm/GetEquipmentList?
      ${queryString.stringify(payload)}`);
      return result.data;
    },
    // 编辑报警设置
    async editAlarm ({ commit }, payload) {
      let result = await http.put(
        `/api/EquipmentAlarm?Id=${payload.id}`,
        payload
      );
      return result.data;
    },
    // 添加报警设置
    async addAlarm ({ commit }, payload) {
      let result = await http.post(`/api/EquipmentAlarm`, payload);
      return result.data;
    },
    // 删除报警设置
    async deleteAlarm ({ commit }, payload) {
      let result = await http.delete(`/api/EquipmentAlarm?Id=${payload}`);
      return result.data;
    },
    //更新报警记录状态
    async updateStatus ({ commit }, payload) {
      let result = await http.post(
        `/api/EquipmentAlarm/UpdateAlarmStatus`,
        payload
      );
      return result.data;
    },
    //获取设备告警优先级设置
    async getEnterSetEquipmentAlarmPriority ({ commit }, payload) {
      let result = await http.get(`/api/EnterpriseSetting/GetEnterSetEquipmentAlarmPriority`);
      return result.data;
    },
    //保存设备告警优先级设置
    async saveEnterSetEquipmentAlarmPriority ({ commit }, payload) {
      let result = await http.post(`/api/EnterpriseSetting/SaveEnterSetEquipmentAlarmPriority`, payload);
      return result.data;
    },
    //获取设备告警风险时间设置
    async getEnterSetEquipmentAlarmTime ({ commit }, payload) {
      let result = await http.get(`/api/EnterpriseSetting/GetEnterSetEquipmentAlarmTime`);
      return result.data;
    },
    //保存设备告警风险时间设置
    async saveEnterSetEquipmentAlarmTime ({ commit }, payload) {
      let result = await http.post(`/api/EnterpriseSetting/SaveEnterSetEquipmentAlarmTime`, payload);
      return result.data;
    },
  },
  mutations: {},
  getters: {}
});

export default moduleName;
